
import { BindEmbCardActions, BindEmbCardActionTypes } from '../actions/bind-emb-card.actions';
import {EmbCardInfo} from '../../../models/devices';

export interface State {
  entity: {};
}

export const initialState: State = {
  entity: {},
};

export function reducer(state = initialState, action: BindEmbCardActions): State {
  switch (action.type) {
    case BindEmbCardActionTypes.LoadBindEmbCards:
      return {...state, entity: action.payload};

    case BindEmbCardActionTypes.ClearBindEmbCards:
      return {...state, entity: {}};

    case BindEmbCardActionTypes.GetBindEmbCards:
      return state;
    default:
      return state;
  }
}
